import { defineMessages } from 'react-intl';

const messages = defineMessages({
  providerSettings: {
    description: 'Header for fulfillment provider settings modal',
    defaultMessage: 'Fulfillment Provider Settings',
    id: 'M/8COJ',
  },
});

export default messages;
